import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http'
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
@Component({
  selector: 'app-student-register',
  templateUrl: './student-register.component.html',
  styleUrls: ['./student-register.component.scss']
})
export class StudentRegisterComponent implements OnInit {
  public showPassword: boolean;
  public showPassword2: boolean;
  timerInterval: NodeJS.Timeout;
  timerInterval2: NodeJS.Timeout;
  isMobValid: any;
  userType: any;
  
  constructor(public router: Router,private fb: FormBuilder,
    private spinner :NgxSpinnerService,
    private modalPopupService: ModalpopService,public umsService:UmsService) { }
  registrationForm: FormGroup;
  dialogRef: MatDialogRef<any>;
  sessionList: any;
  hide = true;
  emaildisabled = false;
  emailverified = false;
  mobileVerified = false;
  otpverify= false;
  otpverify2 = false;
  showerr = false;
  Message = false
  msgshw = false
  msgshw2 =false;
  msgshw3 = false
  msgshw4 =false;
  ErrorMsg = ''
  messageee = ''
  messageee2 = ''
  regibtm = true;
  btnShow = false
btnShow2 = true;
emailInterval :any
isEmailOtpSent: boolean = false;
otpEmailTimer: number = 60;
  emailTimer: any;
  startEmailTimer: boolean = false;
  sendotpmail = false;
  bfrsendotpmail = true
  sendotpmail1: boolean = true;
  isDivDisabled: boolean = false;
  isDivDisabled2: boolean = false;
  remainingTime: number = 60;
  remainingTime2: number = 60;
  resendotp = false;
  resendMobotp = false;
  send1stotp = true;
  send1stMobotp = true;
  isEmailValid: boolean = false;
  isEmailDisabled: boolean = false;
  isMobileDisabled: boolean = false;

  ngOnInit(): void {
    this.userType = this.umsService.getUserType();
    console.log('this.userType',this.userType);
    
    this.Message = false
    this.ErrorMsg = ''
    this.registrationForm = this.fb.group({
      StuFirstName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z .-]*$')]),
      StuMidName: new FormControl('',[ Validators.pattern('^[a-zA-Z .-]*$')]),
      StuLastName: new FormControl('',[Validators.pattern('^[a-zA-Z .-]*$')]),
      // (?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}
      StuEmailId: new FormControl('',[Validators.required,Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]),
      StuMobNumber: new FormControl('',[Validators.required,Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      StuCountryCode: new FormControl(''),
      StuPassword: new FormControl('',Validators.required),
      StuRegStatus: new FormControl(1),
      emailOTP:new FormControl(''),
      mobileOTP: new FormControl(''),
      StuPassword1: new FormControl('',Validators.required),
	    IsRegStudent: new FormControl(false),
      StuRegYear: new FormControl('',[Validators.required,Validators.pattern('^[0-9]{4}$')]),
      StuRegNumber: new FormControl('',Validators.required),
      StuFullName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z .-]*$')]),
    });
    
  }




  togglePasswordVisibility() {
    this.hide = !this.hide;
  }

  registerStudent(){
    this.Message = false
    this.ErrorMsg = ''
    if(this.emailverified){
      this.Message = false
      this.ErrorMsg = ''
      this.spinner.show();
      let payload = this.registrationForm.value;
      if(this.userType == 'new'){
        payload['OldStudent'] = false
      }
      else if(this.userType == 'old'){
        payload['OldStudent'] = true
      }
      
      //return
       this.umsService.studRegistrationDetails(payload).subscribe(res => {
        // this.spinner.hide();
        if (res.status == true) {
          this.spinner.hide();
          this.Message = false
          this.ErrorMsg = ''
          alert('Registered Successfully')
          if(this.userType == 'new'){
            this.redirect('student-login');
          }
          else if(this.userType == 'old'){
            this.redirect('certificate-login');
          }
        
        this.umsService.openSnackbar(res.message);
      }else{
        this.spinner.hide();
        this.Message = true
        this.ErrorMsg = res.message
      }
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.Message = true
        this.ErrorMsg =  ERROR.error.message
        // let data = {}
        //   data['message'] = ERROR.error.message
        //   data['title'] = 'Information'
        //   data['icon'] = 'fas fa-check'
        //   this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        //  this.showerr = true;
        // this.umsService.openSnackbar(ERROR.error.message);
        // alert(ERROR.error.message)
     });
    }else{
      this.Message = true
      this.ErrorMsg =  'Please Verify OTP'
      // this.showerr = true;
      // this.umsService.openSnackbar("Please Verify EmailId");
    }
  
    }

  sendMobWithTimeout(){
    const mobileControl = this.registrationForm.controls['StuMobNumber'];
    if (mobileControl.invalid || this.isDivDisabled2) {
      return; // Exit the function if the mobile is invalid or the button is disabled
    }
    this.isDivDisabled2 = true;
    this.resendMobotp = false;
    this.send1stMobotp = true;
    this.timerInterval2 = setInterval(() => {
      this.remainingTime2--;
      this.isMobileDisabled = true;
      if (this.remainingTime2 === 0) {
        clearInterval(this.timerInterval2);
        this.isDivDisabled2 = false;
        this.remainingTime2 = 60; // Reset the timer for the next attempt
        this.resendMobotp = true;
        this.send1stMobotp = false;
        this.isMobileDisabled = false;
      }
    }, 1000);
    this.SendMobile();
  }

  sendEmailWithTimeout() {
    // if (this.registrationForm.controls['StuEmailId'].invalid || this.isDivDisabled) {
    //   return; // Exit the function if the email is invalid or the button is disabled
    // }
    // if (!this.registrationForm.controls['StuEmailId'].valid ) {
    //   return; // Exit the function if the email is invalid
    // }
    const emailControl = this.registrationForm.controls['StuEmailId'];
    if (emailControl.invalid || this.isDivDisabled) {
      return; // Exit the function if the email is invalid or the button is disabled
    }
    // Disable the div
    this.isDivDisabled = true;
    this.resendotp = false;
    this.send1stotp = true;
    // Start the countdown
    // const timerInterval = setInterval(() => {
    //   this.remainingTime--;

    //   if (this.remainingTime <= 0) {
    //     // Enable the div when the timer reaches 0
    //     this.isDivDisabled = false;
    //     clearInterval(timerInterval);
    //   }
    // }, 1000); // Update the timer every second

    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.isEmailDisabled = true;
      if (this.remainingTime === 0) {
        clearInterval(this.timerInterval);
        this.isDivDisabled = false;
        this.remainingTime = 60; // Reset the timer for the next attempt
        this.resendotp = true;
        this.send1stotp = false;
        this.isEmailDisabled = false;
      }
    }, 1000);

    // Your other logic for sending the email goes here
    this.SendEmail();
  }

  resendMobWithTimeout(){
    this.isDivDisabled2 = true;
    this.resendMobotp = true;
    this.send1stMobotp = false;
    this.msgshw3 = false;
      this.msgshw4 = false;
    this.registrationForm.controls['mobileOTP'].setValue('');
    this.registrationForm.controls['mobileOTP'].clearValidators();
    this.timerInterval2 = setInterval(() => {
      this.remainingTime2--;
       this.isMobileDisabled = true;
      if (this.remainingTime2 === 0) {
        clearInterval(this.timerInterval2);
        this.isDivDisabled2 = false;
        this.remainingTime2 = 60; // Reset the timer for the next attempt
        this.resendMobotp = true;
        this.send1stMobotp = false;
        this.isMobileDisabled = false;
      }
    }, 1000);

    this.SendMobile();
  }

  resendEmailWithTimeout() {
    // Disable the div
    this.isDivDisabled = true;
    this.resendotp = true;
    this.send1stotp = false;
    this.msgshw = false;
      this.msgshw2 = false;
    this.registrationForm.controls['emailOTP'].setValue('');
    this.registrationForm.controls['emailOTP'].clearValidators();
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
       this.isEmailDisabled = true;
      if (this.remainingTime === 0) {
        clearInterval(this.timerInterval);
        this.isDivDisabled = false;
        this.remainingTime = 60; // Reset the timer for the next attempt
        this.resendotp = true;
        this.send1stotp = false;
        this.isEmailDisabled = false;
      }
    }, 1000);

    // Your other logic for sending the email goes here
    this.SendEmail();
  }
  SendEmail(){
      this.emaildisabled = true;
      this.otpverify = false;
      this.spinner.show();
      let payload = {};
      payload['StuEmailId'] = this.registrationForm.value.StuEmailId;
      this.umsService.SendEmail(payload).subscribe(res => {
        if(res.status){
          this.sendotpmail = true;
          this.bfrsendotpmail = false
          this.spinner.hide();
          sessionStorage.setItem("emailotp",res.EmailOtpV);
          this.otpverify = true;
        this.umsService.openSnackbar("Email Sent to - "+this.registrationForm.value.StuEmailId);
        }else{
          this.sendotpmail = false;
          this.bfrsendotpmail = true
        }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.umsService.openSnackbar(ERROR.error.message);
     });
    // }
   
  }

  SendMobile(){
    this.emaildisabled = true;
      this.otpverify2 = false;
      this.spinner.show();
      let payload = {};
      payload['MobNo'] = this.registrationForm.value.StuMobNumber;
      this.umsService.SendMobile(payload).subscribe(res => {
        if(res.status){
          this.sendotpmail = true;
          this.bfrsendotpmail = false
          this.spinner.hide();
          this.otpverify2 = true;
        this.umsService.openSnackbar("Otp Sent to - "+this.registrationForm.value.StuMobNumber);
        }else{
          this.sendotpmail = false;
          this.bfrsendotpmail = true
        }
       
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.umsService.openSnackbar(ERROR.error.message);
     });
  }

  verifyMobOtp(){
    let payload = {};
    payload['MobNo'] = this.registrationForm.value.StuMobNumber;
    payload['OTP'] = this.registrationForm.value.mobileOTP
    this.umsService.VerifyMobile(payload).subscribe(res => {
      console.log('res of verify',res.data);
      if(res.status){
        this.msgshw3 = true;
        this.msgshw4 = false;
        this.otpverify2 = false;
        this.regibtm = false;
        this.btnShow = true;
        this.btnShow2 = false;
        this.messageee2 = "OTP Verified"
      }
      else{
        this.otpverify2 = true;
        this.msgshw3 = false;
        this.msgshw4 = true;
        this.regibtm = true;
        this.btnShow = false;
        this.btnShow2 = true;
        this.messageee2 = "Invalid OTP"
      }
    },(ERROR:HttpErrorResponse) => {
      this.otpverify2 = true;
      this.msgshw3 = false;
      this.msgshw4 = true;
      this.regibtm = true;
      this.btnShow = false;
      this.btnShow2 = true;
      this.messageee2 = "Invalid OTP"
    })
  }

  verifyEmailOtp(){
    let sentotp = sessionStorage.getItem("emailotp");
    let enterotp = this.registrationForm.value.emailOTP;
    if(sentotp == enterotp){
      // alert("OTP Verified");
    //this.umsService.openSnackbar("OTP Verified");
      this.emaildisabled = true;
      this.emailverified = true;
      this.otpverify = false;
      this.msgshw = true;
      this.msgshw2 = false;
      // this.regibtm = false;
      // this.btnShow = true;
      // this.btnShow2 = false;
      this.messageee = "OTP Verified"
    }else{
    //this.umsService.openSnackbar("Invalid Otp");
    // alert("Invalid Otp");
      this.emaildisabled = false;
      this.otpverify = true;
      this.msgshw = false;
      this.msgshw2 = true;
      // this.regibtm = true;
      // this.btnShow = false;
      // this.btnShow2 = true;
      this.messageee = "Invalid OTP"
    }
  }
  SendOtp(){
    this.umsService.openSnackbar("otpotpmobileotp")
  }
  verifymobileOtp(){
    this.mobileVerified = true;
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  SignIn(){
      if(this.userType == 'new'){
        this.redirect('student-login');
      }
      else if(this.userType == 'old'){
        this.redirect('certificate-login');
      }
      
    }

  register() {

  if (this.registrationForm.get('IsRegStudent').value === true) {
    this.registrationForm.get('StuRegNumber').setValidators([Validators.required]);
    this.registrationForm.get('StuRegNumber').updateValueAndValidity();

    this.registrationForm.get('StuRegYear').setValidators([Validators.required]);
    this.registrationForm.get('StuRegYear').updateValueAndValidity();
  } else {
    this.registrationForm.get('StuRegNumber').clearValidators();
    this.registrationForm.get('StuRegNumber').updateValueAndValidity(); 

    this.registrationForm.get('StuRegYear').clearValidators();
    this.registrationForm.get('StuRegYear').updateValueAndValidity();
  }

      if(this.registrationForm.invalid){
        this.Message =false
        // this.showerr = true;
        this.registrationForm.get('StuFirstName').markAsTouched();
        //  this.registrationForm.get('StuMidName').markAsTouched();
        //  this.registrationForm.get('StuLastName').markAsTouched();
         this.registrationForm.get('StuEmailId').markAsTouched();
         this.registrationForm.get('StuMobNumber').markAsTouched();
         this.registrationForm.get('StuPassword').markAsTouched();
         this.registrationForm.get('emailOTP').markAsTouched();
         this.registrationForm.get('StuPassword1').markAsTouched();
		    this.registrationForm.get('IsRegStudent').markAsTouched();
		    this.registrationForm.get('StuFullName').markAsTouched();
         if(this.registrationForm.value['StuPassword'] != this.registrationForm.value['StuPassword1']){
          this.Message = true
          this.ErrorMsg = 'Password and Confirm Password should be same'
        }
        else if(this.registrationForm.value['StuPassword'] == this.registrationForm.value['StuPassword1']){
          this.Message = false
          this.ErrorMsg = ''
        }
      }
      else{
        if(this.registrationForm.value['StuPassword'] != this.registrationForm.value['StuPassword1']){
          this.Message = true
          this.ErrorMsg = 'Password and Confirm Password should be same'
        }
        else if(this.registrationForm.value['StuPassword'] == this.registrationForm.value['StuPassword1']){
          this.Message = false
          this.ErrorMsg = ''
          this.registerStudent();
        }
        } 
}


    isValidEmail(email: string): boolean {
      // const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex: RegExp = /^(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}$/i;
      return emailRegex.test(email);
  }

  isValidMob(num: string): boolean {
    const mobileRegex: RegExp = /^(0|91)?[6-9][0-9]{9}/
    return mobileRegex.test(num);
  }
  
  emailvali(value: string) {
    this.isEmailValid = this.isValidEmail(value);
  }

  mobilevalid(value: string){
    this.isMobValid = this.isValidMob(value);
  }
}